import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../../config/AxiosConfig';
import { ProjectLayoutListResp } from 'domain/payload/response/clientTransmora/projectLayout/ProjectLayoutListResp';
import { ProjectLayoutDetailResp } from 'domain/payload/response/clientTransmora/projectLayout/ProjectLayoutDetailResp';
import { ProjectLayoutConfigResp } from 'domain/payload/response/clientTransmora/projectLayout/ProjectLayoutConfigResp';
import { ProjectDashboardConfigRespData } from 'domain/payload/response/clientTransmora/projectLayout/ProjectDashboardConfigResp';
import { ProjectLayoutCreateReq } from 'domain/payload/request/clientTransmora/projectLayout/ProjectLayoutCreateReq';
import { ProjectLayoutUpdateReq } from 'domain/payload/request/clientTransmora/projectLayout/ProjectLayoutUpdateReq';

const ProjectLayoutService = () => {
  const ProjectLayoutList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null
  ): Promise<BaseResponse<ProjectLayoutListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/client-project-layout/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size
        }
      });

      return response.data;

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectLayoutDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<ProjectLayoutDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/client-project-layout/detail?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data;

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectLayoutConfig = async (
    token: string,
    excludeId: string | undefined
  ): Promise<ProjectLayoutConfigResp> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/client-project-layout/config`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          excludeId: excludeId
        }
      });

      return response.data;

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const DashboardConfig = async (
    token: string,
    projectId: string
  ): Promise<BaseResponse<ProjectDashboardConfigRespData>> => {
    try {
      const response = await axiosInstance.get(
        `/v1/legacy/cms/client-project-layout/dashboard-config`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            projectId: projectId
          }
        }
      );

      return response.data;

    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  const ProjectLayoutCreate = async (
    token: string,
    request: ProjectLayoutCreateReq
  ): Promise<BaseResponse<ProjectLayoutDetailResp>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/client-project-layout/create`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data;

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectLayoutUpdate = async (
    token: string,
    request: ProjectLayoutUpdateReq
  ): Promise<BaseResponse<ProjectLayoutDetailResp>> => {
    try {
      console.log("Final payload:", JSON.stringify(request, null, 2));
      const response = await axiosInstance.put(`/v1/legacy/cms/client-project-layout/update`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });

      return response.data;

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectLayoutDelete = async (
    token: string,
    id: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.delete(
        `/v1/legacy/cms/client-project-layout/delete`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { id },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  return {
    ProjectLayoutList,
    ProjectLayoutDetail,
    ProjectLayoutConfig,
    DashboardConfig,
    ProjectLayoutCreate,
    ProjectLayoutUpdate,
    ProjectLayoutDelete
  };
};

export default ProjectLayoutService;